import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import { usePageTracking } from "@/hooks/usePageTracking";

function PageTracker() {
  usePageTracking();
  return null;
}

const Index = lazy(() => import("./pages/Index"));

const Blinds = lazy(() => import("./pages/Blinds"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Safety = lazy(() => import("./pages/Safety"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const CookiePolicy = lazy(() => import("./pages/CookiePolicy"));
const Accessibility = lazy(() => import("./pages/Accessibility"));
const FAQ = lazy(() => import("./pages/FAQ"));
const AreasHub = lazy(() => import("./pages/AreasHub"));
const AreaPage = lazy(() => import("./pages/AreaPage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <BrowserRouter>
        <PageTracker />
        <Layout>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/blinds" element={<Blinds />} />
              <Route path="/about" element={<About />} />
              <Route path="/enquiry" element={<Contact />} />
              <Route path="/contact" element={<Navigate to="/enquiry" replace />} />
              <Route path="/safety" element={<Safety />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/accessibility" element={<Accessibility />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/areas" element={<AreasHub />} />
              <Route path="/areas/:slug" element={<AreaPage />} />
              <Route path="/blinds-3" element={<Navigate to="/" replace />} />
              <Route path="/curtains" element={<Navigate to="/" replace />} />
              <Route path="/vertical" element={<Navigate to="/" replace />} />
              <Route path="/extras" element={<Navigate to="/" replace />} />
              <Route path="/roller" element={<Navigate to="/" replace />} />
              <Route path="/wooden-blinds" element={<Navigate to="/" replace />} />
              <Route path="/motorised-blinds" element={<Navigate to="/" replace />} />
              <Route path="/vision-blinds" element={<Navigate to="/" replace />} />
              <Route path="/velux-window-blinds" element={<Navigate to="/" replace />} />
              <Route path="/conservatory-blinds" element={<Navigate to="/" replace />} />
              <Route path="/venetian" element={<Navigate to="/" replace />} />
              <Route path="/perfect-fit" element={<Navigate to="/" replace />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </Layout>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
